// extracted by mini-css-extract-plugin
export var circle = "_32-2";
export var icon = "_32-a";
export var iconHighlight = "_32-0";
export var lg = "_32-8";
export var md = "_32-7";
export var outline = "_32-4";
export var sm = "_32-6";
export var square = "_32-1";
export var xl = "_32-9";
export var xs = "_32-5";
export var xxs = "_32-3";